import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/common/index.vue'
import { UserModule } from '@/store/modules/user'
import { SappModule } from '@/store/modules/app'
// import { CAST } from './csat'
import routeManagementRoutes from './map'
import microApp, { getActiveApps } from '@micro-zoe/micro-app'
import dmsPage from '@/views/subapp/dms.vue'
import detailPath from '../components/common/Aside/detailPath.js'
// import sitePage from '@/views/subapp/site.vue'
// import tmsPage from '@/views/subapp/tms.vue'

Vue.use(Router)

export const routes: any = [
  {
    path: '/404',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/404',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
        meta: { title: '找不到该页面', icon: 'el-icon-date-solid' }
      }
    ]
  },

  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/noPermission',
        name: 'noPermission',
        component: () => import(/* webpackChunkName: "noPermission" */ '@/views/noPermission/index.vue'),
        hidden: true
      },
      {
        path: '/home',
        name: 'home1',
        component: () => import(/* webpackChunkName: "Index" */ '@/views/home/index.vue'),
        meta: { title: '首页', icon: '' }
      },
      {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "Index" */ '@/views/home/index.vue'),
        meta: { title: '首页', icon: '' }
      }
    ]
  },
  ...routeManagementRoutes,
  {
    path: '/',
    component: Layout,
    hidden: false,
    children: [
      {
        path: '/st-itms/*',
        name: 'pages-tms',
        meta: {
          appName: 'tms',
          padding: '0px'
        },
        component: () => import(/* webpackChunkName: "pages-tms" */ '@/views/subapp/tms.vue')
      },
      {
        path: '/st-3pl/*',
        name: 'pages-pl',
        meta: {
          appName: 'pl',
          padding: '0px'
        },
        component: () => import(/* webpackChunkName: "pages-pl" */'@/views/subapp/3pl.vue')
      },
      {
        path: '/st-site/*',
        name: 'pages-site',
        meta: {
          appName: 'site',
          padding: '0px'
        },
        component: () => import(/* webpackChunkName: "pages-site" */'@/views/subapp/site.vue')
      },
      {
        path: '/st-dms/*',
        name: 'pages-dms',
        meta: {
          appName: 'dms',
          padding: '0px'
        },
        component: () => import(/* webpackChunkName: "pages-dms" */'@/views/subapp/dms.vue')
      }
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/', hidden: true }
]

// 找不到页面的路由，需要追加在路由表末尾
const notFoundRoutes = [
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const router: any = new Router({
  mode: 'history', // 推荐使用 history 便于埋点统计且地址栏路径较直观
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const whiteList = ['/404', '/noPermission']

// 全局路由状态
let checkStatus: boolean = false

// 前端校验路由权限 [通过接口返回的路由与本地全量的路由进行对比]
const checkRouterRole = (routers: any, checkRouter: string) => {
  routers.forEach((route: any) => {
    if (route.name === checkRouter) {
      checkStatus = true
      return checkStatus
    }
    return (route.children && route.children.length && checkRouterRole(route.children, checkRouter))
  })
  return checkStatus
}
const removeLastSegment = (str: string) => {
  // 找到最后一个斜杠的位置
  const lastSlashIndex = str ? str.lastIndexOf('/') : -1

  // 如果找到了斜杠，则返回从开始到最后一个斜杠之前的部分
  // 否则返回原字符串
  return lastSlashIndex !== -1 ? str.substring(0, lastSlashIndex) : str
}
const nextHandler = async(to:any, next:any, params?: any) => {
  const path = to.path
  let appName = 'tms'
  if (to.meta.appName) {
    appName = to.meta.appName
  }
  if (params) {
    await next({ ...params })
  } else {
    await next()
  }
  if (['AdmissionFenceMapDisplay', 'DriverMap', 'VehicleTrajectory', 'EndToEndTracking', 'Staff', 'PlStaff', 'ItmsStaff', 'IDmsStaff'].includes(to.name)) {
    return
  }
  //  && getActiveApps().includes(appName)
  if (appName) { // 需要先等待主应用路由的next执行完，再判断是否是子应用然后下发路由
    const childPath = path.replace(/\/st-site|\/st-itms|\/st-dms|\/st-3pl/g, '') || '/'
    const childParams = to.params
    const childQuery = to.query
    // if (['production', 'gray', 'holl', 'hollgray'].includes(process.env.NODE_ENV || '')) {
    //   CAST(to, to.meta.title)
    // }
    microApp.setData(appName, {
      data: {
        params: childParams || {},
        query: childQuery || {},
        path: childPath
      },
      type: 'routerPush'
    })
  }
}

const hasActive = (show:string) => {
  const container = document.getElementById('itms-top-tabs')
  if (container) {
    const elements = container.querySelectorAll('.el-tabs__active-bar.is-top')
    if (elements) {
      elements.forEach(function(element: any) {
        element.style.display = show
      })
    }
  }
}
const findTopParentIndexByURL = (menu: any, url:any) => {
  let i: number = -1
  menu.forEach((node: any, index: number) => {
    if (node.url === url) {
      i = index
    } else if (node && node.children && node.children.length) {
      node.children.forEach((item: any, m: number) => {
        if (item.url === url) {
          i = index
        } else if (item && item.children && item.children.length) {
          item.children.forEach((item2: any, m1: number) => {
            if (item2.url === url) {
              i = index
            }
          })
        }
      })
    }
  })
  return i
}
router.afterEach((to: any) => {
  const menus: any[] = SappModule.menus
  const plMenus: any[] = SappModule.plMenus
  const oceanMenus: any[] = SappModule.oceanMenus
  const path = to.path
  const pathArr = ['/st-3pl/baseInfo/carrier', '/st-3pl/serviceProvider/dockingManage']
  if (pathArr.includes(path)) {
    const menus: any[] = SappModule.menus
    const index = findTopParentIndexByURL(menus, path)
    console.log('是否找到权限', index)
    if (index < 0) {
      router.push({
        path: '/noPermission'
      })
      return
    }
  }
  if (to.name === 'pages-site' || to.name === 'AdmissionFenceMapDisplay' || to.name === 'DriverMap' || to.name === 'Staff' || to.name === 'isiteTrajectoManage') {
    SappModule.setTopMenuActiveIndex(menus.findIndex(e => e.code === 'DispatchManagement'))
    SappModule.SHOW_SIDEBAR()
    setTimeout(() => {
      hasActive('block')
    }, 200)
  } else if (to.name === 'pages-tms' || to.name === 'VehicleTrajectory' || to.name === 'ItmsStaff') {
    if (to.path === '/st-itms/trunkIine/report/index') {
      const index = findTopParentIndexByURL(plMenus, to.fullPath)
      // TODO   此处3pl分了很多个菜单  需要逐一区分 fun 把3pl分多个子路由出来？
      SappModule.setTopMenuActiveIndex(menus.findIndex(e => e.code === plMenus[index].code))
      SappModule.SHOW_SIDEBAR()
      setTimeout(() => {
        hasActive('block')
      }, 0)
    } else {
      let index = findTopParentIndexByURL(menus, to.fullPath)
      if (index > -1) {
        SappModule.setTopMenuActiveIndex(index)
      } else {
        const path = to.path.replace('/st-itms/', '')
        let url = detailPath.find((e: any) => e.path === path)
        if (url) {
          index = findTopParentIndexByURL(menus, `/st-itms/${url.activePath}`)
        }
        if (index > -1) {
          SappModule.setTopMenuActiveIndex(index)
        } else {
          url = detailPath.find((e: any) => e.path === removeLastSegment(path))
          if (url && url.activePath) {
            index = findTopParentIndexByURL(menus, `/st-itms/${url.activePath}`)
            if (index > -1) {
              SappModule.setTopMenuActiveIndex(index)
            } else {
              SappModule.setTopMenuActiveIndex(menus.findIndex(e => e.code === 'ITMS-TransportationManage'))
            }
          } else {
            SappModule.setTopMenuActiveIndex(menus.findIndex(e => e.code === 'ITMS-TransportationManage'))
          }
        }
      }

      SappModule.SHOW_SIDEBAR()
    }

    setTimeout(() => {
      hasActive('block')
    }, 200)
  } else if (to.name === 'pages-pl' || to.name === 'EndToEndTracking' || to.name === 'PlStaff') {
    setTimeout(() => {
      hasActive('block')
    }, 0)
    try {
      const index = findTopParentIndexByURL(plMenus, to.fullPath)
      SappModule.setTopMenuActiveIndex(menus.findIndex(e => e.code === plMenus[index].code))
      SappModule.SHOW_SIDEBAR()
    } catch (error) {
      console.log(error)
    }
    // TODO   此处3pl分了很多个菜单  需要逐一区分 fun 把3pl分多个子路由出来？
  } else if (to.name === 'pages-dms' || to.name === 'IDmsStaff' || to.name === 'dmsTrajectoManage' || to.name === 'idmsTrajectoManage') {
    SappModule.setTopMenuActiveIndex(menus.findIndex(e => e.code === 'LogisticsManagement'))
    SappModule.SHOW_SIDEBAR()
    setTimeout(() => {
      hasActive('block')
    }, 0)
  } else {
    SappModule.setTopMenuActiveIndex(-1)
    hasActive('none')
  }
})
// 路由守卫
router.beforeEach(async(to: any, from: any, next: any) => {
  if (to.name !== 'home' && to.name !== 'noPermission' && to.name !== '404') {
    if (to.path.indexOf('/404') < 0 || to.path.indexOf('ocean') > -1) {
      SappModule.addTab({
        ...to
      })
    }
  }
  if (to.path.indexOf('/404') > -1 && to.name !== '404' && to.path.indexOf('ocean') < 0) {
    SappModule.removeTab(to.path)
    next({
      path: '/'
    })
    return
  }

  if (whiteList.includes(to.path)) {
    next()
    return
  }
  SappModule.setEditableTabsValue(to.path)
  SappModule.INIT_FRAMEWORK()
  // 使用keepAlive缓存组件
  SappModule.KEEP_ALIVE(to.name)
  // // 重置路由状态
  checkStatus = false
  // 获取用户信息
  if (!UserModule.username) {
    await UserModule.getUserInfo()
  }
  // // // 获取菜单
  if (!SappModule.menus.length) {
    await SappModule.getMenus(next)
  }
  // // 校验菜单权限
  const routerWhiteList = ['/', '404']
  if (to.path && to.path.indexOf('st-itms') > -1) {
    SappModule.setTopMenuActiveIndex(0)
  } else if (to.path && to.path === '/') {
    SappModule.setTopMenuActiveIndex(-1)
  }
  // TODO   checkRouterRole  根据权限返回是否可以跳转？实际不行  因为detail路由均未设置权限
  nextHandler(to, next)
})

export default router
